/* eslint-disable @typescript-eslint/naming-convention */
import update from 'immutability-helper';

import {APP_SET_USER, APP_CLEAR_USER} from './actions';
import {AppActionType, AppState} from './types';

const initialState: AppState = {
  user: {
    role: '',
    name: '',
    email: '',
    terms_accepted: false,
  },
};

export default function appReducer(
  state = initialState,
  action: AppActionType
): AppState {
  const {type, payload} = action;

  switch (type) {
    case APP_SET_USER:
      return update(state, {
        user: {$set: payload.user || state.user},
      });
    case APP_CLEAR_USER:
      return update(state, {
        user: {$set: initialState.user},
      });
    default:
      return state;
  }
}
